module.exports = {"330225001":"丹东街道","330225002":"丹西街道","330225003":"爵溪街道","330225101":"石浦镇","330225102":"西周镇","330225103":"鹤浦镇","330225104":"贤庠镇","330225105":"墙头镇","330225106":"泗洲头镇","330225107":"定塘镇","330225108":"涂茨镇","330225109":"大徐镇","330225110":"新桥镇","330225200":"东陈乡","330225201":"晓塘乡","330225202":"黄避岙乡","330225203":"茅洋乡","330225204":"高塘岛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330225.json
// module id = 1064
// module chunks = 0